

export default () => {
  const currentYear = new Date().getFullYear();
  
  return <div class="footer">
    <div>
      Copyright © {currentYear} <strong>Shadowz Admin Panel</strong> All rights reserved.
    </div>
  </div>
}